import { Clear } from "@procore/core-icons";
import { Box, Button, spacing, Typography } from "@procore/core-react";
import { ReactNode } from "react";

import { HEADER_BORDER } from "./constants";

export interface BaseWindowHeaderProps {
    title: string;
    subtitle?: string;
    children?: ReactNode;
    onClose?: () => void;
    noBorder?: boolean;
}

export function BaseWindowHeader({ title, subtitle, children, onClose, noBorder = false }: BaseWindowHeaderProps) {
    return (
        <>
            <Box
                padding="lg"
                style={{
                    cursor: "move",
                    userSelect: "none",
                    borderBottom: noBorder || subtitle || children ? undefined : HEADER_BORDER,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <Box display="flex" flexDirection="column" style={{ flex: 1 }}>
                        <Typography
                            intent={subtitle ? "small" : "h3"}
                            weight="semibold"
                            color={subtitle ? "gray45" : undefined}
                        >
                            {title}
                        </Typography>
                        {subtitle && (
                            <Box style={{ marginTop: spacing.xs }}>
                                <Typography intent="h3" weight="semibold">
                                    {subtitle}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Box style={{ display: "flex" }}>
                        <Button icon={<Clear />} variant="tertiary" size="sm" onClick={onClose} />
                    </Box>
                </Box>
            </Box>
            {children}
        </>
    );
}
